import React, { useEffect, useState } from 'react';
import { BrowserView } from "react-device-detect"
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Font, Image } from '@react-pdf/renderer';
import { prefectureName } from '../../constants';

import { makeStyles } from '@material-ui/core/styles';

import SpaceRow from '../commons/SpaceRow';
import EgsMEntryAdminNew from "./EgsMEntryAdmin";
import EgsMEntryAdminUpd from "./EgsMEntryAdmin";
import EgsMEntryAdminDel from "./EgsMEntryAdmin";
import EgsMEntryNew from "./EgsMEntryNew";
import EgsMEntryUpd from "./EgsMEntryUpd";
import EgsMEntryDel from "./EgsMEntryDel";
import EgsMEntryNewEdit from "./EgsMEntryNewEdit";
import EgsMEntryUpdEdit from "./EgsMEntryUpdEdit";
import EgsMEntryDelEdit from "./EgsMEntryDelEdit";
import './app.css';

import {
  Button,
  TextField,
  Box,
  Grid,
  Backdrop,
  CircularProgress,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper
} from '@material-ui/core';
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridColumnMenu,
  jaJP
} from '@mui/x-data-grid-pro'
import { getEntryOperation } from '../../lib/api/entry';
import { getEgsMTraderUser } from '../../lib/api/egs_m_trader';

// Register Japanese font
Font.register({
  family: 'NotoSansJP',
  src: require('./fonts/NotoSansJP-Regular.ttf')
});

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          fileName: '加入者登録・変更・解約一覧',
          utf8WithBom: true,
        }}
      />
    </GridToolbarContainer>
  )
}

function CustomColumnMenu(props) {
  return (
    <GridColumnMenu
      {...props}
      componentsProps={{
        columnMenuFilterItem: {
          displayOrder: 0,
        },
      }}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  fontWeight: {
    fontWeight: 900,
  },
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '100ch',
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  container: {
    borderWidth: 1,
    borderColor: "#CCC",
    borderStyle: "solid",
    marginBottom: 8,
    width: "85vw",
    margin: "auto",
  },
  container2: {
    borderWidth: 1,
    borderColor: "#CCC",
    borderStyle: "solid",
    marginBottom: 8,
    width: "1000px",
    margin: "auto",
  },
  row: {
    borderWidth: 0,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: "#CCC",
  },
  title_box: {
    background: "#EEE",
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "#CCC",
    borderStyle: "solid",
    height: "100%",
  },
  value_box: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderStyle: "solid",
    borderColor: "#CCC",
  },
}));

const pdfStyles = StyleSheet.create({
  page: {
    padding: 50,
    paddingLeft: 40,
    paddingRight: 40,
    fontSize: 12,
    fontFamily: 'NotoSansJP',
  },
  header: {
    marginBottom: 20,
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'NotoSansJP',
  },
  headerWithDate: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'NotoSansJP',
    position: 'relative',
  },
  headerText: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'NotoSansJP',
    width: '100%',
  },
  effectiveDate: {
    fontSize: 12,
    fontFamily: 'NotoSansJP',
    position: 'absolute',
    right: 0,
    top: 40,
  },
  underline: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'NotoSansJP',
    marginTop: -5,
  },
  address: {
    marginBottom: 20,
    fontFamily: 'NotoSansJP',
  },
  content: {
    marginBottom: 20,
    fontFamily: 'NotoSansJP',
  },
  lineBreak: {
    height: 20,
  },
  rightAlign: {
    textAlign: 'right',
    fontFamily: 'NotoSansJP',
  },
  footer: {
    marginTop: 30,
    fontFamily: 'NotoSansJP',
    textAlign: 'right',
  },
  note: {
    color: 'red',
    marginTop: 10,
    fontFamily: 'NotoSansJP',
  },
  documents: {
    marginTop: 20,
    fontFamily: 'NotoSansJP',
  },
  centerAlign: {
    textAlign: 'center',
    fontFamily: 'NotoSansJP',
  },
  blueText: {
    color: '#0000FF',
    fontFamily: 'NotoSansJP',
  },
  addressText: {
    fontSize: 14,
    fontFamily: 'NotoSansJP',
  },
  table: {
    display: 'table',
    width: '100%',
    marginTop: 20,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCell: {
    width: '75%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    padding: 5,
  },
  tableCellHeader: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    padding: 5,
    backgroundColor: '#f0f0f0',
  },
  tableCellQuarter: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    padding: 5,
  },
  tableCellQuarterSmall: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    padding: 5,
    fontSize: 8,
  },
  tableCellQuarterHeader: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    padding: 5,
    backgroundColor: '#f0f0f0',
  },
  tableCellTitle: {
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    padding: 5,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  cautionNotes: {
    marginTop: 10,
    fontSize: 9,
    fontFamily: 'NotoSansJP',
    lineHeight: 1.5,
    left: 20,
  },
  footerContainer: {
    marginTop: 50,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'absolute',
    bottom: 50,
    right: 40,
    left: 40,
  },
  footerLogo: {
    width: 100,
    height: 'auto',
  },
  footerInfo: {
    fontSize: 10,
    fontFamily: 'NotoSansJP',
    lineHeight: 1.5,
    textAlign: 'right',
    marginLeft: 30,
  },
});

const CoverLetterPDF = ({ data }) => (
  <Document>
    <Page size="A4" style={pdfStyles.page}>
      <Text style={pdfStyles.rightAlign}>{dayjs().format('YYYY年MM月DD日')}</Text>      
      <View style={pdfStyles.address}>
        <Text style={pdfStyles.addressText}>{data.demandName} 御中</Text>
      </View>
      <View style={pdfStyles.lineBreak} />
      <View style={pdfStyles.lineBreak} />

      <View style={pdfStyles.header}>
        <Text style={pdfStyles.headerText}>書 類 送 付 案 内</Text>
      </View>

      <View style={pdfStyles.content}>
        <Text>拝啓　時下ますますご清祥のこととお慶び申し上げます。</Text>
        <View style={pdfStyles.lineBreak} />
        <Text>平素は格別のご高配を賜り、厚くお礼申し上げます。</Text>
        <Text>さて、下記の書類をお送りいたしますので、業務ご多忙の折お手数をおかけし</Text>
        <Text>大変申し訳ございませんが、加入者様へお渡しいただきますようよろしく</Text>
        <Text>お願い申し上げます。</Text>
        <Text style={pdfStyles.rightAlign}>敬具</Text>
      </View>
      <View style={pdfStyles.lineBreak} />

      <View style={pdfStyles.content}>
        <Text style={pdfStyles.centerAlign}>記</Text>
        <View style={pdfStyles.lineBreak} />
        <Text>{data.companyName} 様</Text>
        <Text style={[pdfStyles.centerAlign, pdfStyles.blueText]}>利用開始日 {dayjs().format('YYYY年MM月DD日')} ～</Text>
      </View>

      <View style={pdfStyles.documents}>
        <Text>　・利用証 1部</Text>
        <Text>　・受取証明書 1部</Text>
        <Text>　・SDGs推進システム利用規約 1部</Text>
        <Text>　・SDGs推進システム操作説明書 1部</Text>
        <Text style={pdfStyles.note}>※注意 利用証は廃棄物を出される時に必要になりますので、紛失されないよう保管をお願いいたします。</Text>
      </View>

      <View style={pdfStyles.footer}>
        <Text>NPO法人エコ・テクル事務局</Text>
        <Text>〒812-0013　　　　　　　　</Text>
        <Text>福岡市博多区博多駅東1-1-25</Text>
        <Text>宝ビル6階</Text>
        <Text>Tel：092-474-2280</Text>
        <Text>Fax：092-474-2285</Text>
        <Text>URL：https://www.ecotechl.com</Text>
        <Text>Eメール：info@ecotechl.com</Text>
      </View>

    </Page>
  </Document>
);

const CompanyCoverLetterPDF = ({ data }) => (
  <Document>
    <Page size="A4" style={pdfStyles.page}>
      <Text style={pdfStyles.rightAlign}>{dayjs().format('YYYY年MM月DD日')}</Text>      
      <View style={pdfStyles.address}>
        <Text style={pdfStyles.addressText}>{data.companyName} 御中</Text>
      </View>
      <View style={pdfStyles.lineBreak} />
      <View style={pdfStyles.lineBreak} />

      <View style={pdfStyles.header}>
        <Text style={pdfStyles.headerText}>書 類 送 付 案 内</Text>
      </View>

      <View style={pdfStyles.content}>
        <Text>拝啓　時下ますますご清祥のこととお慶び申し上げます。</Text>
        <View style={pdfStyles.lineBreak} />
        <Text>平素は格別のご高配を賜り、厚くお礼申し上げます。</Text>
        <Text>さて、下記の書類をお送りいたしますので、ご査収いただきますよう</Text>
        <Text>お願い申し上げます。</Text>
        <Text style={pdfStyles.rightAlign}>敬具</Text>
      </View>
      <View style={pdfStyles.lineBreak} />

      <View style={pdfStyles.content}>
        <Text style={pdfStyles.centerAlign}>記</Text>
        <View style={pdfStyles.lineBreak} />
        <Text style={[pdfStyles.centerAlign, pdfStyles.blueText]}>利用開始日 {dayjs().format('YYYY年MM月DD日')} ～</Text>
      </View>

      <View style={pdfStyles.documents}>
        <Text>　・利用証 1部</Text>
        <Text>　・受取証明書 1部</Text>
        <Text>　・SDGs推進システム利用規約 1部</Text>
        <Text>　・SDGs推進システム操作説明書 1部</Text>
        <Text style={pdfStyles.note}>※注意　利用開始日以前に利用されますと、システムエラーが発生しますので、ご注意願います。</Text>
      </View>

      <View style={pdfStyles.footer}>
        <Text>NPO法人エコ・テクル事務局</Text>
        <Text>〒812-0013　　　　　　　　</Text>
        <Text>福岡市博多区博多駅東1-1-25</Text>
        <Text>宝ビル6階</Text>
        <Text>Tel：092-474-2280</Text>
        <Text>Fax：092-474-2285</Text>
        <Text>URL：https://www.ecotechl.com</Text>
        <Text>Eメール：info@ecotechl.com</Text>
      </View>

    </Page>
  </Document>
);

const LicensePDF = ({ data }) => {
  const [traderData, setTraderData] = useState(null);

  useEffect(() => {
    const fetchTraderData = async () => {
      try {
        const response = await getEgsMTraderUser(data.traderCd);
        console.log("response", response);
        if (response.data && response.data.length > 0) {
          setTraderData(response.data[0]);
        }
      } catch (error) {
        console.error('Error fetching trader data:', error);
      }
    };

    if (data.traderCd) {
      fetchTraderData();
    }
  }, [data.traderCd]);

  const formatAddress = (trader) => {
    if (!trader) return '';
    const prefecture = prefectureName[trader.prefectureCd] || '';
    
    // Format zip code from 7 digits to XXX-XXXX format
    let formattedZip = trader.zip || '';
    if (formattedZip.length === 7) {
      formattedZip = `${formattedZip.substring(0, 3)}-${formattedZip.substring(3)}`;
    }
    
    return `〒${formattedZip}　${prefecture}${trader.address}${trader.address2}${trader.address3}${trader.address4}`;
  };

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <View style={pdfStyles.headerWithDate}>
          <Text style={pdfStyles.headerText}>JWNET　EDI版利用証＆SDGs推進システム利用証</Text>
          <Text style={pdfStyles.effectiveDate}>発効日：{dayjs().format('YYYY/MM/DD')}</Text>
        </View>
        <View style={pdfStyles.lineBreak} />
        <View style={pdfStyles.table}>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellTitle}>JWNET　EDI版（https://www.jwnetweb.jp）　利用証</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>JWNET加入者番号</Text>
            <Text style={pdfStyles.tableCell}>{traderData?.jwnetNo || ''}</Text>
          </View>
          {/* <View style={pdfStyles.tableRow}>            
            <Text style={pdfStyles.tableCellHeader}>ログインパスワード</Text>
            <Text style={pdfStyles.tableCell}>別紙　JWNET 加入内容のお知らせ　参照</Text>
          </View> */}
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>EDI利用確認キー</Text>
            <Text style={pdfStyles.tableCell}>{traderData?.jwnetEdipass || ''}</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>加入区分</Text>
            <Text style={pdfStyles.tableCell}>
              {data.traderKbn === '1000000000' ? '排出事業者' : 
               data.traderKbn === '0100000000' ? '収集運搬事業者' : 
               data.traderKbn}
            </Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>加入者名称</Text>
            <Text style={pdfStyles.tableCell}>{data.traderName}</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>代表者氏名</Text>
            <Text style={pdfStyles.tableCell}>{data.daihyo}　{data.daihyoName1}　{data.daihyoName2}</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>住所</Text>
            <Text style={pdfStyles.tableCell}>{formatAddress(traderData)}</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellQuarterHeader}>電話番号</Text>
            <Text style={pdfStyles.tableCellQuarter}>{traderData?.phone || ''}</Text>
            <Text style={pdfStyles.tableCellQuarterHeader}>FAX番号</Text>
            <Text style={pdfStyles.tableCellQuarter}>{traderData?.fax || ''}</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellQuarterHeader}>E メール1</Text>
            <Text style={pdfStyles.tableCellQuarterSmall}>{traderData?.email1 || ''}</Text>
            <Text style={pdfStyles.tableCellQuarterHeader}>E メール2</Text>
            <Text style={pdfStyles.tableCellQuarterSmall}>{traderData?.email2 || ''}</Text>
          </View>
        </View>

        {/* <View style={pdfStyles.lineBreak} /> */}
        <View style={pdfStyles.table}>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellTitle}>SDGs推進システム（https://www.sdgs12.com）　利用証</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>システム名称</Text>
            <Text style={pdfStyles.tableCell}>産業廃棄物SDGs推進システム（SDGs12システム）</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>EDI接続登録番号</Text>
            <Text style={pdfStyles.tableCell}>20752865</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>接続登録者名称</Text>
            <Text style={pdfStyles.tableCell}>特定非営利活動法人　エコ・テクル</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>SDGs12　事業者ID</Text>
            <Text style={pdfStyles.tableCell}>{data.traderCd}</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>SDGs12　パスワード</Text>
            <Text style={pdfStyles.tableCell}>{traderData?.rawpasswd || ''}</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>承認コード</Text>
            <Text style={pdfStyles.tableCell}>{traderData?.exhaustPasswd || ''}</Text>
          </View>
          <View style={pdfStyles.tableRow}>
            <Text style={pdfStyles.tableCellHeader}>利用開始可能日</Text>
            <Text style={pdfStyles.tableCell}>{dayjs(data.henkouDate).format('YYYY/MM/DD')}　4時～</Text>
          </View>
        </View>
        <View style={pdfStyles.cautionNotes}>
          <Text>● 本票には、パスワード等記載されているため盗難・紛失されることのないよう、取り扱いには十分ご注意ください。</Text>
          <Text>● 登録内容に誤りや変更がある場合は、サポートセンターまでご連絡ください。</Text>
        </View>

        <View style={pdfStyles.footerContainer}>
          <Image style={pdfStyles.footerLogo} src={require('../../ecotechl_logo2.png')} />
          <View style={pdfStyles.footerInfo}>
            <Text>特定非営利活動法人エコ・テクル</Text>
            <Text>TEL: 092-474-2280　FAX: 092-474-2285</Text>
            <Text>URL: https://www.ecotechl.com</Text>
            <Text>Email: info@ecotechl.com</Text>
          </View>
        </View>

      </Page>
    </Document>
  );
};

function EgsMEntryListTable(props) {
  const classes = useStyles();
  const [open2, setOpen2] = useState(false);
  const { dataList, handleDelete, currentUser } = props;
  const [rows, setRows] = useState(dataList);
  const [dataList2, setDataList2] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [filteredDataList, setFilteredDataList] = useState([]);
  const [filter, setFilter] = useState({
    traderName: '',
    traderCd: '',
    sect1TransportName: ''
  });

  const [adminNewOpen, setAdminNewOpen] = useState(false);
  const [adminUpdOpen, setAdminUpdOpen] = useState(false);
  const [adminDelOpen, setAdminDelOpen] = useState(false);
  const [newOpen, setNewOpen] = useState(false);
  const [updOpen, setUpdOpen] = useState(false);
  const [delOpen, setDelOpen] = useState(false);
  const [newEditOpen, setNewEditOpen] = useState(false);
  const [updEditOpen, setUpdEditOpen] = useState(false);
  const [delEditOpen, setDelEditOpen] = useState(false);
  const [coverLetterOpen, setCoverLetterOpen] = useState(false);

  const query = useParams();
  const pdfRef = React.createRef();

  var param_item = '';

  useEffect(() => {
    setFilteredDataList(dataList);
  }, [dataList, currentUser]);

  const startFilter = () => {
    param_item = `${currentUser.traderCd}_${currentUser.traderKbn}_${filter.traderCd}_${filter.traderName}_`;
    handleGetList(param_item);
  };

  const handleGetList = async (param_item) => {
    setOpen2(true);
    try {
      const res = await getEntryOperation(param_item);
      setFilteredDataList(res.data);
    } catch (e) {
      console.error('Error fetching data:', e);
    }
    setOpen2(false);
  };

  const handleAdminNewOpen = () => {
    setAdminNewOpen(true);
  };
  const handleAdminUpdOpen = () => {
    setAdminUpdOpen(true);
  };
  const handleAdminDelOpen = () => {
    setAdminDelOpen(true);
  };
  const handleNewOpen = () => {
    setNewOpen(true);
  };
  const handleUpdOpen = () => {
    setUpdOpen(true);
  };
  const handleDelOpen = () => {
    setDelOpen(true);
  };
  const handleNewEditOpen = () => {
    setNewEditOpen(true);
  };
  const handleUpdEditOpen = () => {
    setUpdEditOpen(true);
  };
  const handleDelEditOpen = () => {
    setDelEditOpen(true);
  };

  const handleCoverLetterOpen = () => {
    setCoverLetterOpen(true);
  };

  const handleCoverLetterClose = () => {
    setCoverLetterOpen(false);
  };

  const handleRowClick = (param, event) => {
    setDataList2(param.row);
  };

  const delRows = () => {
    handleDelete(dataList2);
  };

  const handleDetailClick = React.useCallback((params) => (event) => {
    event.stopPropagation();
    console.log(`handleDetailClick:id=${params.id}`);
  }, []);

  const getRowClassName = (params) => {
    if (params.row.effectiveName === '2:登録完了') {
      return 'finish-row';
    } else if (params.row.effectiveName === '1:申請済') {
      return 'apply-row';
    }
    return '';
  };

  const cols1 = [
    {field: 'id', headerName: 'ID', width: 50},
    {field: 'henkouDate', headerName: '変更予定日', width: 100},
    {field: 'entryDate', headerName: 'お申込日', width: 100},
    {field: 'henkouKbn', headerName: '変更区分', hide: true, width: 20},
    {field: 'henkouKbnName', headerName: '変更区分名', width: 100},
    {field: 'effectiveName',headerName: '申請状況',width: 100},
    {field: 'demandCd', headerName: '請求先CD', width: 100, hide:true},
    {field: 'demandName', headerName: '請求先', width: 200},

    {field: 'jwnetNo',headerName: '加入者番号',width: 100},

    {field: 'companyKana', headerName: '企業かな', hide: true,width: 200},
    {field: 'companyName', headerName: '企業名', width: 200},
    {field: 'daihyoName', headerName: '代表者', width: 150},
    {field: 'daihyo', headerName: '代表者役職', width: 100},
    {field: 'daihyoKana1', headerName: '代表者かな1',hide: true, width: 100},
    {field: 'daihyoKana2', headerName: '代表者かな2',hide: true, width: 100},
    {field: 'daihyoName1', headerName: '代表者名1', hide: true, width: 100},
    {field: 'daihyoName2',headerName: '代表者名2', hide: true,width: 100},

    {field: 'traderCd',headerName: '事業場CD',hide: true,width: 120},
    {field: 'traderKana',headerName: '事業場かな',hide: true,width: 120},
    {field: 'traderName',headerName: '事業場名',width: 120},
    {field: 'traderKbn',headerName: '事業者区分',hide: true,width: 100},
    {field: 'chargeName',headerName: '担当者名',width: 100},
    {field: 'chargeKana1',headerName: '担当者かな1',hide: true,width: 100},
    {field: 'chargeKana2',headerName: '担当者かな2',hide: true,width: 100},
    {field: 'chargeName1',headerName: '担当者名1', hide: true, width: 100},
    {field: 'chargeName2',headerName: '担当者名2', hide: true, width: 100},

    {field: 'traderFullAddress',headerName: '住所',width: 200},
    {field: 'zip',headerName: '郵便番号',hide: true,width: 80},
    {field: 'pref',headerName: '都道府県',hide: true,width: 80},
    {field: 'city',headerName: '市区町村',hide: true,width: 100},
    {field: 'town',headerName: '町域',hide: true,width: 100},
    {field: 'address',headerName: '詳細住所',hide: true,width: 100},
    {field: 'building',headerName: 'ビル名',hide: true,width: 100},
    {field: 'phone',headerName: '電話番号',width: 100},
    {field: 'fax',headerName: 'FAX番号',hide: true,width: 100},
    {field: 'email1',headerName: 'メールアドレス1',hide: true,width:100},

    {field: 'officeChargeKana1',headerName: '事務担当者かな1',hide: true,width: 100},
    {field: 'officeChargeKana2',headerName: '事務担当者かな2',hide: true,width: 100},
    {field: 'officeChargeName1',headerName: '事務担当者名1',hide: true,width: 100},
    {field: 'officeChargeName2',headerName: '事務担当者名2',hide: true,width: 100},

    {field: 'chargeDivision',headerName: '料金区分',width: 100},
    {field: 'business',headerName: '職種',width: 100},
    {field: 'group1',headerName: 'グループ１',width: 100},
    {field: 'group2',headerName: 'グループ２',width: 100},
    {field: 'jwnetEdipass',headerName: 'EDI版パスワード',hide: true,width: 100},
    {field: 'rawpasswd',headerName: 'パスワード',hide: true,width: 80},
    {field: 'exhaustPasswd',headerName: '承認コード',hide: true,width: 80},

    {field: 'companyKind',headerName: '法人区分',hide: true,width: 50},
    {field: 'companyKindName',headerName: '法人区分名',hide: true,width: 100},
    {field: 'companyKbn',headerName: '法人位置',hide: true,width: 50},
    {field: 'companyKbnName',headerName: '法人位置名',hide: true,width: 50},
  ]

  const cols2 = [
    {field: 'id', headerName: 'ID', width: 50},
    {field: 'henkouDate', headerName: '変更予定日', width: 100},
    {field: 'entryDate', headerName: 'お申込日', width: 100},
    {field: 'henkouKbn', headerName: '変更区分', hide: true, width: 20},
    {field: 'henkouKbnName', headerName: '変更区分名', width: 100},
    {field: 'effectiveName',headerName: '申請状況',width: 100},
    {field: 'demandCd', headerName: '請求先CD', width: 100, hide:true},
    {field: 'demandName', headerName: '請求先', hide: true, width: 200},

    {field: 'jwnetNo',headerName: '加入者番号',width: 100},

    {field: 'companyKana', headerName: '企業かな', hide: true,width: 200},
    {field: 'companyName', headerName: '企業名', width: 200},
    {field: 'daihyoName', headerName: '代表者', width: 150},
    {field: 'daihyo', headerName: '代表者役職', width: 100},
    {field: 'daihyoKana1', headerName: '代表者かな1',hide: true, width: 100},
    {field: 'daihyoKana2', headerName: '代表者かな2',hide: true, width: 100},
    {field: 'daihyoName1', headerName: '代表者名1', hide: true, width: 100},
    {field: 'daihyoName2',headerName: '代表者名2', hide: true,width: 100},

    {field: 'traderCd',headerName: '事業場CD',hide: true,width: 120},
    {field: 'traderKana',headerName: '事業場かな',hide: true,width: 120},
    {field: 'traderName',headerName: '事業場名',width: 120},
    {field: 'traderKbn',headerName: '事業者区分',hide: true,width: 100},
    {field: 'chargeName',headerName: '担当者名',width: 100},
    {field: 'chargeKana1',headerName: '担当者かな1',hide: true,width: 100},
    {field: 'chargeKana2',headerName: '担当者かな2',hide: true,width: 100},
    {field: 'chargeName1',headerName: '担当者名1', hide: true, width: 100},
    {field: 'chargeName2',headerName: '担当者名2', hide: true, width: 100},

    {field: 'traderFullAddress',headerName: '住所',width: 200},
    {field: 'zip',headerName: '郵便番号',hide: true,width: 80},
    {field: 'pref',headerName: '都道府県',hide: true,width: 80},
    {field: 'city',headerName: '市区町村',hide: true,width: 100},
    {field: 'town',headerName: '町域',hide: true,width: 100},
    {field: 'address',headerName: '詳細住所',hide: true,width: 100},
    {field: 'building',headerName: 'ビル名',hide: true,width: 100},
    {field: 'phone',headerName: '電話番号',width: 100},
    {field: 'fax',headerName: 'FAX番号',hide: true,width: 100},
    {field: 'email1',headerName: 'メールアドレス1',hide: true,width:100},

    {field: 'officeChargeKana1',headerName: '事務担当者かな1',hide: true,width: 100},
    {field: 'officeChargeKana2',headerName: '事務担当者かな2',hide: true,width: 100},
    {field: 'officeChargeName1',headerName: '事務担当者名1',hide: true,width: 100},
    {field: 'officeChargeName2',headerName: '事務担当者名2',hide: true,width: 100},

    {field: 'chargeDivision',headerName: '料金区分',width: 100},
    {field: 'business',headerName: '職種',width: 100},
  ]

  const qrCodeUrl = "https://www.sdgs12.com/" + dataList2.traderKbn + "/" + dataList2.traderCd + "/" + dataList2.entryCd
  console.log('qrCodeUrl',qrCodeUrl);

  const CoverLetterDialog = () => {
    if (!dataList2 || !dataList2.demandName) return null;

    return (
      <Dialog
        open={coverLetterOpen}
        onClose={handleCoverLetterClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>送付用PDF作成</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center', height: '240px' }}>
            <PDFDownloadLink
              document={<CoverLetterPDF data={dataList2} />}
              fileName="書類送付案内１.pdf"
              style={{
                textDecoration: 'none',
                padding: '10px 20px',
                color: '#fff',
                backgroundColor: '#1976d2',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              {({ blob, url, loading, error }) =>
                loading ? 'PDFを生成中...' : '請求先向け書類送付案内PDFをダウンロード'
              }
            </PDFDownloadLink>
            <PDFDownloadLink
              document={<CompanyCoverLetterPDF data={dataList2} />}
              fileName="書類送付案内２.pdf"
              style={{
                textDecoration: 'none',
                padding: '10px 20px',
                color: '#fff',
                backgroundColor: '#1976d2',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              {({ blob, url, loading, error }) =>
                loading ? 'PDFを生成中...' : '加入者向け書類送付案内PDFをダウンロード'
              }
            </PDFDownloadLink>
            <PDFDownloadLink
              document={<LicensePDF data={dataList2} />}
              fileName="利用証.pdf"
              style={{
                textDecoration: 'none',
                padding: '10px 20px',
                color: '#fff',
                backgroundColor: '#1976d2',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              {({ blob, url, loading, error }) =>
                loading ? 'PDFを生成中...' : '利用証PDFをダウンロード'
              }
            </PDFDownloadLink>
            <Button
              onClick={() => {
                window.open('https://s3-sdgs12com-manual.s3.ap-northeast-1.amazonaws.com/SDGs12TermsofUse_20230201.pdf', '_blank');
              }}
              style={{
                textDecoration: 'none',
                padding: '10px 20px',
                color: '#fff',
                backgroundColor: '#1976d2',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: 'bold',
                marginTop: '10px',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              利用規約PDFをダウンロード
            </Button>
            <Button
              onClick={() => {
                window.open('https://s3-sdgs12com-manual.s3.ap-northeast-1.amazonaws.com/sdgs12_sousa_1000000000.pdf', '_blank');
              }}
              style={{
                textDecoration: 'none',
                padding: '10px 20px',
                color: '#fff',
                backgroundColor: '#1976d2',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: 'bold',
                marginTop: '10px',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              操作説明書PDFをダウンロード
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCoverLetterClose} color="primary">
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <BrowserView>
      {currentUser.traderKbn === '1111111111' ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}>
              <Typography variant="h7" style={{ fontWeight: 700 }}>　事業場Cd：</Typography>
              <TextField 
                id="traderCd" 
                value={filter.traderCd} 
                onChange={e => setFilter({ ...filter, traderCd: e.target.value })} 
                label="" 
                type="text" 
                className={classes.textField} 
                InputLabelProps={{ shrink: true }} 
              />
              <Typography variant="h7" style={{ fontWeight: 700 }}>　事業場名称：</Typography>
              <TextField 
                id="traderName" 
                value={filter.traderName} 
                onChange={e => setFilter({ ...filter, traderName: e.target.value })} 
                label="" 
                type="text" 
                className={classes.textField} 
                InputLabelProps={{ shrink: true }} 
              />
              <Button
                type='button' 
                variant='contained' 
                color='primary' 
                onClick={startFilter} 
                style={{ marginLeft: 24 }}
              >
                データ表示
              </Button>
              <Typography variant="body2" style={{ marginLeft: 8 }}>MAX：3000件</Typography>
            </Grid>
          </Grid>

          <Backdrop className={classes.backdrop} open={open2}>
            <CircularProgress color="inherit" />
          </Backdrop>

          <div className={classes.container}>
            <Box sx={{ height: 520, width: '100%' }}>
              <DataGridPro
                sx={styles.grid}
                columns={cols1}
                rows={filteredDataList}
                density="compact"
                components={{
                  Toolbar: CustomToolbar,
                }}
                showColumnRightBorder
                showCellRightBorder
                localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                onRowClick={handleRowClick}
                getRowClassName={getRowClassName}
              />
            </Box>
          </div>
          
          <Box component='div' sx={{ p: 1, textAlign: 'right' }}>
            <Button variant="contained" color='primary' style={{ marginRight: 10 }} onClick={handleCoverLetterOpen} disabled={!dataList2.id || !dataList2.demandName}>
              送付用PDF作成
            </Button>
          </Box>
          <Box component='div' sx={{textAlign: 'left' }}>
          </Box>
        
          <EgsMEntryAdminNew isOpen={adminNewOpen} doClose={() => setAdminNewOpen(false)} dataList2={dataList2} processId={dataList2.id}/>
          <EgsMEntryAdminUpd isOpen={adminUpdOpen} doClose={() => setAdminUpdOpen(false)} dataList2={dataList2} processId={dataList2.id}/>
          <EgsMEntryAdminDel isOpen={adminDelOpen} doClose={() => setAdminDelOpen(false)} dataList2={dataList2} processId={dataList2.id}/>
          <SpaceRow height={20} />
          <Box component='div' sx={{ p: 2, textAlign: 'right' }}></Box>
          <div className={classes.container2}>
            <Box component='div' sx={{ p: 2, textAlign: 'left' }}>
              <Button variant="contained" color="primary" style={{ marginRight: 10 }} onClick={handleAdminNewOpen} disabled={dataList2.henkouKbn !== '1'} dataList2={dataList2} processId={dataList2.id}>
                加入申込編集
              </Button>
              <Button variant="contained" color="primary" style={{ marginRight: 10 }} onClick={handleAdminUpdOpen} disabled={dataList2.henkouKbn !== '2'} dataList2={dataList2} processId={dataList2.id}>
                変更申込編集
              </Button>
              <Button variant="contained" color="primary" style={{ marginRight: 100 }} onClick={handleAdminDelOpen} disabled={dataList2.henkouKbn !== '3'} dataList2={dataList2} processId={dataList2.id}>
                解約申込編集
              </Button>
              <Button variant="contained" color='secondary' onClick={delRows} disabled={!dataList2.id}>
                申込削除
              </Button>
            </Box>
          </div>
          <CoverLetterDialog />
        </>
      ) : (
        <>
          <Backdrop className={classes.backdrop} open={open2}>
            <CircularProgress color="inherit" />
          </Backdrop>

          <div className={classes.container}>
            <Box sx={{ height: 520, width: '100%' }}>
              <DataGridPro
                sx={styles.grid}
                columns={cols2}
                rows={filteredDataList}
                density="compact"
                components={{
                  Toolbar: CustomToolbar,
                }}
                showColumnRightBorder
                showCellRightBorder
                localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                onRowClick={handleRowClick}
                getRowClassName={getRowClassName}
              />
            </Box>
          </div>

          <EgsMEntryAdminNew isOpen={adminNewOpen} doClose={() => setAdminNewOpen(false)} dataList2={dataList2} processId={dataList2.id}/>
          <EgsMEntryNew isOpen={newOpen} doClose={() => setNewOpen(false)} currentUser={currentUser}/>
          <EgsMEntryUpd isOpen={updOpen} doClose={() => setUpdOpen(false)} currentUser={currentUser}/>
          <EgsMEntryDel isOpen={delOpen} doClose={() => setDelOpen(false)} currentUser={currentUser}/>

          <EgsMEntryNewEdit isOpen={newEditOpen} doClose={() => setNewEditOpen(false)} currentUser={currentUser} dataList2={dataList2} processId={dataList2.id}/>
          <EgsMEntryUpdEdit isOpen={updEditOpen} doClose={() => setUpdEditOpen(false)} currentUser={currentUser} dataList2={dataList2} processId={dataList2.id}/>
          <EgsMEntryDelEdit isOpen={delEditOpen} doClose={() => setDelEditOpen(false)} currentUser={currentUser} dataList2={dataList2} processId={dataList2.id}/>

          <SpaceRow height={20} />
          <Box component='div' sx={{ p: 2, textAlign: 'right' }}></Box>
          <div className={classes.container2}>
            <Box component='div' sx={{ p: 2, textAlign: 'left' }}>

              <Button variant="contained" color="primary" style={{ marginRight: 10 }} onClick={handleNewOpen}>
                加入申込
              </Button>
              <Button variant="contained" color="primary" style={{ marginRight: 10 }} onClick={handleUpdOpen}>
                変更申込
              </Button>
              <Button variant="contained" color="primary" style={{ marginRight: 100 }} onClick={handleDelOpen}>
                解約申込
              </Button>

              <Button variant="contained" color="secondary" style={{ marginRight: 10 }} onClick={handleNewEditOpen} disabled={dataList2.henkouKbn !== '1'} dataList2={dataList2} processId={dataList2.id}>
                加入申込編集
              </Button>
              <Button variant="contained" color="secondary" style={{ marginRight: 10 }} onClick={handleUpdEditOpen} disabled={dataList2.henkouKbn !== '2'} dataList2={dataList2} processId={dataList2.id}>
                変更申込編集
              </Button>
              <Button variant="contained" color="secondary" style={{ marginRight: 100 }} onClick={handleDelEditOpen} disabled={dataList2.henkouKbn !== '3'} dataList2={dataList2} processId={dataList2.id}>
                解約申込編集
              </Button>
              <Button variant="contained" color='secondary' onClick={delRows} disabled={!dataList2.id}>
                申込削除
              </Button>

            </Box>
          </div>
        </>
      )}
    </BrowserView>
  );
}

const styles = {
  grid: {
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: '#65b2c6',
      color: '#fff',
    },
    '& .finish-row': {
      backgroundColor: '#666460',
    },
    '& .apply-row': {
      backgroundColor: '#f5ce93',
    }
  }
};

export default EgsMEntryListTable;